
<template>
  <el-dialog
    title="同步操作"
    :visible.sync="dialogVisible"
    modal-append-to-body
    append-to-body
    destroy-on-close
    width="600px"
    :close-on-click-modal="false"
    @closed="handelClosed"
  >
    <div v-loading="loading">
      <el-form :model="form" ref="form" label-width="120px">
        <el-form-item label="选择店铺" prop="shopId"
          :rules="[
            { required: true, message: '请选择店铺', trigger: ['blur', 'change'] }
          ]"
        >
          <el-select @change="handleSelect" v-model="form.shopId" placeholder="请选择店铺" style="width:300px;">
            <el-option v-for="(item,index) in shopIdList" :key="index" :label="item.shopName" :value="item.shopId"></el-option>
          </el-select>
        </el-form-item>
        <template v-if="form.shopId">
          <div style="display: flex;" v-for="(item, index) in form.items" :key="index">
            <el-form-item
              :label="'商品ID ' + (index + 1)"
              :prop="'items.' + index + '.id'"
              :rules="[
          { required: true, message: '请输入商品ID', trigger: 'blur' },
          { pattern: /^\+?[0-9]*$/, message: '商品ID必须是数字', trigger: 'blur' },
          { validator: duplicateValidator, trigger: 'blur' }
        ]"
            >
              <el-input style="width:300px;margin-right: 10px;" v-model="item.id"></el-input>
              <!--            <el-button-->
              <!--              v-if="index > 0"-->
              <!--              icon="el-icon-delete"-->
              <!--              @click="removeItem(index)"-->
              <!--            >删除</el-button>-->
            </el-form-item>
            <el-form-item label="" label-width="0px">
              <el-button
                v-if="form.items.length > 1"
                icon="el-icon-delete"
                @click="removeItem(index)"
              >删除</el-button>
            </el-form-item>
          </div>
          <el-form-item>
            <el-button type="primary" @click="addItem">添加商品ID</el-button>
          </el-form-item>
        </template>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button :loading="subLoading" type="primary" @click="submitForm">提交</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import mini from "@/api/mini";
const MiniModel = new mini();
import debounce from "@/utils/debounce.js";
export default {
  data() {
    return {
      loading:false,
      subLoading:false,
      dialogVisible: false,
      form: {
        shopId:'',
        items: [
          // {id: ''}
        ]
      },
      isHttps:false,
      // 未查询到的商品ID集合
      notFindList:[],
      shopIdList:[],
    };
  },
  methods: {
    openDialog() {
      // this.form.items = [
      //   {
      //     id: ''
      //   }
      // ];
      this.dialogVisible = true;
      this.loading = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      })
      this.getDyDdCouponQueryShop().finally(() => {
        this.loading = false;
      });
    },
    close() {
      this.dialogVisible = false;
    },
    handleSelect(val) {
      console.log(val,'val==1')
      this.form.items = [
        {
          id: ''
        }
      ];
      this.$refs.form.clearValidate();
    },
    addItem() {
      this.form.items.push({id: '', key: Date.now()});
    },
    removeItem(index) {
      if(this.form.items.length === 1) {
        this.$message.error('至少保留一个商品ID');
        return;
      }
      // 清除当前删除项的校验状态
      this.$refs.form.clearValidate(`items.${index}.id`);

      // 删除对应的表单项
      this.form.items.splice(index, 1);
      this.handelAgainValidate()
    },
    // 再次校验
    handelAgainValidate() {
      // 重新清理所有的校验状态，防止校验项索引错位
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
        this.$refs.form.validate(valid => {
          if (valid) {
            // alert('提交成功!');
          } else {
            // alert('请修正表单错误后提交！');
          }
        });
      });
    },

    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          debounce(async() => {
            let productIdListValue = [];
            this.form.items.forEach(item => {
              productIdListValue.push(item.id)
            })
            console.log(productIdListValue.join(','), '通过===');
            // this.$emit('submit', productIdListValue.join(','));
            let appKeyMini = localStorage.getItem("appKeyMini");
            let parms = {
              // miniAppKey:appKeyMini,
              productIdStr: productIdListValue.join(','),
              shopId:this.form.shopId, //店铺id
              appKey:this.shopIdList.filter(item => item.shopId === this.form.shopId)[0].appKey
            }
            console.log(parms,'parms==1')
            // return
            this.subLoading = true;
            const res = await MiniModel.dyDdCouponSyncCouponV3(parms).finally(() => {
              this.subLoading = false;
            })
            console.log(res,'同步抖店商品券')
            if(res.data.code === 200) {
              this.$message.success('同步成功');
              this.dialogVisible = false;
              this.$emit('submit');
            }else{
              this.$message.error(res.data.message)
              this.handelNotFindId(res.data.data)
              this.$emit('submit');
            }
          }, 1000, true)
        } else {
          console.log('校验error submit!!');
          // alert('请修正表单错误后提交！');
        }
      });
    },
    duplicateValidator(rule, value, callback) {
      console.log(typeof value,value,'value==1===',this.isHttps,typeof this.notFindList,typeof this.notFindList[0])
      // 接口未查询到的商品ID，主动触发校验
      if(this.isHttps && this.notFindList.length > 0) {
        // console.log(this.notFindList.includes(Number(value)),'this.notFindList.includes(value)')
        if(this.notFindList.includes(Number(value))){
          callback(new Error('商品ID未查询到'));
        }else{
          // 检查重复项
          const ids = this.form.items.map(item => item.id);
          const counts = ids.filter(id => id === value).length;
          if (counts > 1) {
            callback(new Error('输入的值不能重复'));
          } else {
            callback();
          }
        }
      }else{
        console.log('BB===')
        // 检查重复项
        const ids = this.form.items.map(item => item.id);
        const counts = ids.filter(id => id === value).length;
        if (counts > 1) {
          callback(new Error('输入的值不能重复'));
        } else {
          callback();
        }
      }
    },
    handelNotFindId(list) {
      console.log(list,'list==1')
      this.notFindList = list
      this.isHttps = true;
      this.handelAgainValidate()
    },
    handelClosed() {
      console.log('关闭==')
      this.isHttps = false;
      this.notFindList = []
      this.form.shopId = ''
      this.form.items = []
      this.shopIdList = []
    },
    async getDyDdCouponQueryShop() {
      let appKeyMini = localStorage.getItem("appKeyMini");
      const res = await MiniModel.dyDdCouponQueryShopV3({
        miniAppKey:appKeyMini
      })
      console.log(res,'抖音查询商铺信息')
      if(res.data.code === 200) {
        this.shopIdList = res.data.data
        // this.shopIdList = [
        //   {
        //     shopId:22277625,
        //     shopName:"卡券测试店铺1",
        //   },
        //   {
        //     shopId:22277626,
        //     shopName:"卡券测试店铺2",
        //   },
        //   {
        //     shopId:22277627,
        //     shopName:"卡券测试店铺3",
        //   }
        // ]
      }else{
        this.$message.error(res.data.message)
      }
    },
  }
};
</script>

<style scoped lang="less">
.dialog-footer {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/ksCouponExchange/ddCouponSynchronization/component/addCoupon.vue